import { render, staticRenderFns } from "./attrManage.vue?vue&type=template&id=33853f09&scoped=true"
import script from "./attrManage.vue?vue&type=script&lang=js"
export * from "./attrManage.vue?vue&type=script&lang=js"
import style0 from "./attrManage.vue?vue&type=style&index=0&id=33853f09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33853f09",
  null
  
)

export default component.exports